import React, { Component } from "react";
import { PostData } from "../../api/service";
import { Divider } from "antd";
import { Container, Typography } from "@material-ui/core";
import AliceCarousel from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";

const handleDragStart = (e) => e.preventDefault();

export default class StudentPlacement extends Component {
  state = {
    loadedData: [],
    isLoaded: false,
  };

  componentDidMount() {
    PostData(`/getphotosforwebsitewithcaption`, {
      type: "HIGHLIGHTS",
    }).then((resp) => {
      this.setState({
        loadedData: resp,
        isLoaded: true,
      });
    });
  }

  render() {
    return (
      <div className="achievement-section">
        {/* TITLE */}
        {/* <Divider className="achievement-title">STUDENT ACHIEVEMENTS</Divider> */}

        <Container>
          <AliceCarousel
            mouseTracking
            autoPlay={true}
            infinite={true}
            autoPlayInterval={2000}
            animationDuration={500}
            buttonsDisabled={true} // ✅ OLD VERSION support
            dotsDisabled={true} // optional
            items={this.state.loadedData
              .filter((el) => el.type === "HIGHLIGHTS")
              .map((el, index) => (
                <div key={index} className="achievement-card">
                  <img
                    src={el.url}
                    onDragStart={handleDragStart}
                    className="achievement-img"
                  />

                  <Typography className="achievement-caption">
                    {el.caption}
                  </Typography>
                </div>
              ))}
          />
        </Container>

        {/* ================= CSS ================= */}
        <style jsx>{`
          .achievement-section {
            background: #f4f6f7;
            padding: 20px 10px;
          }

          .achievement-title {
            font-weight: 700;
            font-size: 20px;
            color: #1e3760;
            border-color: #d5d8dc !important;
            text-align: center;
          }

          .achievement-card {
            padding: 10px;
            text-align: center;
          }

          .achievement-img-wrapper {
            background: #fff;
            padding: 10px;
            border-radius: 10px;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
          }

          .achievement-img {
            width: 100%;
            height: 350px;
            object-fit: cover;
            border-radius: 8px;
          }

          .achievement-caption {
            margin-top: 15px;
            font-size: 14px;
            font-weight: 600;
            color: #2c3e50;
            text-align: center;
            line-height: 1.5;
          }

          /* Hover Effect */
          .achievement-img-wrapper:hover {
            transform: translateY(-5px);
            transition: 0.3s;
            box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
          }

          /* Responsive */
          @media (max-width: 768px) {
            .achievement-img {
              height: 250px;
            }
          }
        `}</style>
      </div>
    );
  }
}
